import * as z from "zod";

export const LoginSchema = z.object({
  email: z.email(),
  password: z.string()
});

export type LoginFormDataType = z.infer<typeof LoginSchema>;
